export default __webpack_public_path__ + "static/media/skillBanner2.6a5069f9.png";